import React from 'react';
import { Container, Row, Table } from 'reactstrap';
import './styles.scss';
import { LicenseModel } from '../../../../core/domainModels/licences/LicenseModel';
import { dateToStringFormat } from '../../../../core/helpers/moment';
import { LicenseTachoModule } from '../../../../core/domainModels/modules/LicenseTachoModule';
import { Client } from '../../../../core/domainModels/clients/Client';
import { formatToYesOrNo } from '../../../components/AgGrid/services';
import { Icon, TooltipType, TsrSvgIcon, TsrTooltip } from 'tacho-ui';
import { downloadLicense } from '../../../../core/api/endpoints/licences/licensesApi';
import { maxInt } from '../../../modals/licences/services/licenceService';

interface LicenceVersionDetailsProps {
    data?: Client;
    licenceData: Array<LicenseModel>;
    formatMessage: ({ id }: { id: string }) => string;
}

export const LicenceVersionDetails = (props: LicenceVersionDetailsProps) => {
    const allowedModules = (modules: Array<LicenseTachoModule>) => {
        return modules.map((item: LicenseTachoModule) => {
            return `${props.formatMessage({ id: item.tachoModuleId })} : ${item.maximumLoggedUsers}`;
        });
    };
    return (
        <Container className="licencesVersionDetailsContainer d-flex flex-column px-5 mt-2 gap-3">
            {props.licenceData.map(licence => {
                return (
                    <Row>
                        <h6 className="d-flex align-items-center gap-3 p-0">
                            <span>
                                {props.formatMessage({ id: 'licencesNumber' })}: {licence.friendlyLicenseNumber}
                            </span>
                            <TsrTooltip type={TooltipType.Info} icon content={props.formatMessage({ id: 'licenceDownload' })}>
                                <TsrSvgIcon
                                    icon={Icon.Download}
                                    titleIcon
                                    onClick={() =>
                                        downloadLicense(licence.licenseNumber).then(link => {
                                            link.click();
                                        })
                                    }
                                />
                            </TsrTooltip>

                            <span>
                                {props.formatMessage({ id: 'licencesIsServiceEdition' })}:{' '}
                                {formatToYesOrNo(licence.isServiceEdition, props.formatMessage)}
                            </span>
                        </h6>

                        <Table className="licenceTableContainer my-1" bordered borderless>
                            <thead>
                                <tr>
                                    <th>{props.formatMessage({ id: 'licencesValidFrom' })}</th>
                                    <th>{props.formatMessage({ id: 'licencesValidTo' })}</th>
                                    <th>{props.formatMessage({ id: 'licencesPaymentDeadline' })}</th>
                                    <th>{props.formatMessage({ id: 'licencesMaximumNumberOfSupportedCars' })}</th>
                                    <th>{props.formatMessage({ id: 'licencesPaymentStatus' })}</th>
                                    <th>{props.formatMessage({ id: 'licencesLicenseType' })}</th>
                                    <th colSpan={3}>{props.formatMessage({ id: 'licencesAllowedModules' })}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {licence.licenseVersions &&
                                    licence.licenseVersions.map(item => (
                                        <tr>
                                            <td>{dateToStringFormat(item.validFrom)}</td>
                                            <td>{dateToStringFormat(item.validTo)}</td>
                                            <td>{dateToStringFormat(item.paymentDeadline)}</td>
                                            <td>
                                                {item.maximumNumberOfSupportedCars === maxInt
                                                    ? props.formatMessage({ id: 'licenceCarsFull' })
                                                    : item.maximumNumberOfSupportedCars}
                                            </td>
                                            <td>{props.formatMessage({ id: item.paymentStatus })}</td>
                                            <td>{props.formatMessage({ id: item.type })}</td>
                                            {allowedModules(item.allowedModules).map(item => (
                                                <td>{item}</td>
                                            ))}
                                        </tr>
                                    ))}
                            </tbody>
                        </Table>
                        {licence.licenseVersions && (
                            <div className="mt-3">
                                <strong>{props.formatMessage({ id: 'clientNotes' })}:</strong>{' '}
                                {licence.licenseVersions
                                    .map(v => v.notes) // or another field name if it's not `notes`
                                    .filter(note => !!note) // exclude undefined/null/empty notes
                                    .join(', ')}
                            </div>
                        )}
                    </Row>
                );
            })}
        </Container>
    );
};
